export default "__VITE_ASSET__77769f4c__"